import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'content';

const generateSlug = async (
  params: definitions['CONTENT_SLUG_PARAMS'],
): Promise<API.Response<definitions['CONTENT_SLUG']>> => {
  return await cruisesAPI.http.post({
    resource: `${resource}/slug`,
    body: params,
  });
};

const generateHeadline = async (
  params: definitions['CONTENT_HEADLINE_PARAMS'],
): Promise<API.Response<definitions['CONTENT_HEADLINE']>> => {
  return await cruisesAPI.http.post({
    resource: `${resource}/headline`,
    body: params,
  });
};

const generateDescription = async (
  params: definitions['CONTENT_DESCRIPTION_PARAMS'],
): Promise<API.Response<definitions['CONTENT_DESCRIPTION']>> => {
  return await cruisesAPI.http.post({
    resource: `${resource}/description`,
    body: params,
  });
};

export default {
  generateSlug,
  generateHeadline,
  generateDescription,
};
